<script>
import { Doughnut } from "vue-chartjs";

export default {
    name: "IpOriginHitGaugeChart",
    extends: Doughnut,
    props: {
        originStats: {
            type: Object,
            default: () => ({
                hit: 0,
                miss: 0,
                hitRate: 0,
            }),
        },
    },
    watch: {
        originStats: {
            immediate: false,
            handler() {
                this.renderGauge();
            },
        },
    },
    mounted() {
        this.renderGauge();
    },
    methods: {
        renderGauge() {
            const { hit, miss } = this.originStats;
            const total = hit + miss;
            let rate = total > 0 ? (hit / total) * 100 : 0;

            // 保護：限制在 0–100 之間
            rate = Math.max(0, Math.min(100, rate || 0));

            const data = {
                labels: [this.$t("behaviorAnalyze.hitOrigin"), this.$t("behaviorAnalyze.missOrigin")],
                datasets: [
                    {
                        // [0]:有打到源站 ; [1]沒打到源站 => 加起來要 100
                        data: [rate, 100 - rate],
                        // [0]:有打到源站 ; [1]沒打到源站
                        backgroundColor: ["#EE6983", "#e0e0e0"],
                        borderWidth: 0,
                    },
                ],
            };

            const options = {
                responsive: true,
                maintainAspectRatio: false,
                // 只畫半圓，像儀表板
                rotation: Math.PI, // 從 180 度開始
                circumference: Math.PI, // 半圓
                cutoutPercentage: 70, // 中間挖空比例
                aspectRatio: 2, // 撐到寬 2:1
                layout: { padding: 20 },
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        label(tooltipItem, chartData) {
                            const dataset = chartData.datasets[tooltipItem.datasetIndex];
                            const value = dataset.data[tooltipItem.index] || 0;
                            const label = chartData.labels[tooltipItem.index] || "";
                            // value 本身就是 0–100 的數字
                            const percentage = value.toFixed(1).replace(/\.0$/, "");
                            return `${label}: ${percentage}%`;
                        },
                    },
                },
            };

            this.renderChart(data, options);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Chart/IpOriginHitGaugeChart.vue